<template>
    <span class="ma-0 cursor-help" @mouseout="isVisible = false">
        <v-tooltip
            v-model="isVisible"
            activator="parent"
            content-class="kl-tooltip bg-bg-focused text-secondary-dark text-size-lg py-2 px-3"
            rounded="lg"
            location="bottom"
            max-width="350px"
            open-on-click
            :open-on-hover="!mobile"
            close-on-content-click
            :close-delay="200"
            :touch-delay="200"
            >{{ message }}</v-tooltip
        >
        <slot />
    </span>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { IToolTip } from '../types';
import { useDisplay } from 'vuetify';
defineProps<IToolTip>();

const isVisible = ref(false);
const { mobile } = useDisplay();
</script>
